import { cn } from '../lib';
import { Typography } from './typography';

export const EmptyState = ({
  description = 'Check if the input is right',
  className,
}: {
  description?: string;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex h-full w-full flex-col items-center justify-center gap-1 text-center',
        className,
      )}
    >
      <Typography className="text-xl">No results found</Typography>
      <Typography className="text-sm font-normal text-base-300">
        {description}
      </Typography>
    </div>
  );
};
